/**
 * Proformas list (ADR-0032) — preliminary, non-fiscal sale documents.
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { ProformaListPage } from "../../../../features/proformas/index.ts";

export const Route = createFileRoute("/(workspace)/sales/proformas/")({
  component: ProformasListRoute,
});

function ProformasListRoute() {
  return (
    <WorkspaceShell breadcrumbs={[{ label: "Sales" }, { label: "Proformas" }]}>
      <ProformaListPage />
    </WorkspaceShell>
  );
}
